export const PARENT_DEMOGRAPHICS_DETAILS_LABELS = {
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  USERNAME: 'Username',
  ID: 'ID',
  STATE: 'State',
};
export const CONTACT_DETAILS_LABELS = {
  HEADING: 'Contact Details',
  COUNTRY_CODE: 'Country Code',
  PHONE: 'Phone',
  EMAIL: 'Email',
};

export const FIELD_TYPE = {
  FIELD: 'field',
  LINK: 'link',
};
